import configVars from "@/config/config_vars";
let appBaseUrl = configVars.appBaseUrl;

import axios from "axios";

import querystring from "querystring";




/**
 *
 * @param {*} param0
 * @param {*} params
 */
var getFee = async () => {
 
    let consulta = `${appBaseUrl}db/fee`;
    let instance = axios.create();
    instance.defaults.headers.common = {};
  
     let  data=  {
        value: 0.21
      }
   

    try {
      let response = await instance.get(consulta)
      data = response.data

    } catch (error) {
      
    }

    return data
   
      
}



var createUpdateFees = (value) => {
  return new Promise((resolve, reject) => {
    let instance = axios.create();
    instance.defaults.headers.common = {};

    instance
      .post(`${appBaseUrl}db/fee/`, value)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}





export default {
  getFee,
  createUpdateFees
}
